// src/Pages/Login.js
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLogin } from "../Hooks/useLogin";
import { useAuthContext } from "../Hooks/useauthContext";
import '../Styles/Login.css'; // Using the same theme with added styles below
import Navbar from '../Components/Navbar';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login, error, isLoading } = useLogin();
  const { user, authIsReady } = useAuthContext();
  const navigate = useNavigate();

  // Auto-redirect if a user is already logged in
  useEffect(() => {
    if (authIsReady && user) {
      navigate('/dashboard');
    }
  }, [authIsReady, user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Call the login hook and await its result.
    const result = await login(email, password);

    // Only navigate if login was successful.
    if (result) {
      navigate('/dashboard');
    }
    // If login fails, the hook's error state is set and will display below.
  };

  const handleForgotPassword = async (e) => {
    navigate('/forgot-password');
  };

  return (
    <div className='login-page'>
      <Navbar />
      {/* New Center Layout: Removed the side-by-side sign-up section */}
      <div className="login-container">
        {/* Login Form Section */}
        <div className="login-form-section">
          {/* Logo and Title - keeping original comments */}
          <div className="logo">
            <img src="/RoboFication_Logo.png" alt="RoboFication Logo" className="logo-img" />
            <Link to="/" className="title">RoboFication</Link>
          </div>
          <h2>Login to Your Account</h2>
          {error && <p className="error-message">{error}</p>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {/* Updated Forgot Password button with enhanced styling and spacing */}
            <div className="login-forgot-password-container">
              <Link to="/forgot-password" className='forgot-link'>
                Forgot Password?
              </Link>
            </div>
            <button type="submit" disabled={isLoading}>
              {isLoading ? 'Signing In...' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;